export const Images = {
  omniLogo: require('./OCLogo.png'),
};
